/**
 * Filter props to get data-* or data[A-Z]* props
 *
 * @param {*} allProps props to filter
 */
export const pickDataProps = allProps => Object.keys(allProps).filter(key => key.match(/^data-|^data[A-Z]/)).reduce((out, key) => ({
  ...out,
  [key]: allProps[key]
}), {});

/**
 * Filter props to get data-test* or dataTest[A-Z]* props
 *
 * @param {*} allProps props to filter
 */
export const pickDataTestProps = allProps => Object.keys(allProps).filter(key => key.match(/^data-test-|^dataTest[A-Z]/)).reduce((out, key) => ({
  ...out,
  [key]: allProps[key]
}), {});